/**
 * @description: 出品汇总表
 * @author: lyr
*/
<template>
    <div class="gsr-cph-report">
        <div class="cph-list">
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="cphTime">
                        <input type="text" class="form-control laydate-icon" v-model="cphStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="cphEndTime">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="cph_shop" data-placeholder="请选择门店"></select>
                </div>
                <label class="list-label-4">商品类型:</label>
                <div class="col-md-2 ct-col">
                    <input class="form-control white" placeholder="请选择商品类型" v-model="cph_goods_type_str" readonly @click="openGoodsTypePop"></input>
                </div>
                <label class="list-label-4">商品名称:</label>
                <div class="col-md-2">
                    <input class="form-control" placeholder="请输入商品名称" v-model="cph_name">
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-4">包厢区域:</label>
                <div class="col-md-2">
                    <input class="form-control white" placeholder="请选择包厢区域" v-model="room_area_str" readonly @click="openRoomAreaPop">
                </div>
                <label class="list-label-4">出货仓库:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ex_store" data-placeholder="请选择仓库">
                    </select>
                </div>
                <label class="list-label-4">价格策略:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="bill_price_rule" data-placeholder="请选择价格策略"></select>
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitSzmTable" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getSzmExportSet">导出</button>
                </div>
            </div>
            <!-- <div class="row row-margin flex-row">
                <div class="tip">出品数量：<span ref="cph_total">0</span></div>
            </div> -->

            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="cphList"></table>
            </div>
            <div class="check-sum" @click="doSum">查看合计金额</div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="cphExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='cphExport_allcheck' @click='cphExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='cphExport_checkModel' value="shop_name">
                            <label>门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='cphExport_checkModel' value="goods_type_name">
                            <label>商品类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='cphExport_checkModel' value="goods_name">
                            <label>商品名称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='cphExport_checkModel' value="goods_unit_name">
                            <label>单位</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='cphExport_checkModel' value="discount_price">
                            <label>单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='cphExport_checkModel' value="sale_quantity">
                            <label>销售数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='cphExport_checkModel' value="pack_quantity">
                            <label>套餐数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='cphExport_checkModel' value="give_quantity">
                            <label>赠送数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='cphExport_checkModel' value="present_quantity">
                            <label>配送数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='cphExport_checkModel' value="exchange_quantity">
                            <label>商品兑换数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='cphExport_checkModel' value="total_quantity">
                            <label>出品总量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='cphExport_checkModel' value="price_total">
                            <label>出品总额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='cphExport_checkModel' value="buying_price">
                            <label>进货单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='cphExport_checkModel' value="buying_price_total">
                            <label>进货总额</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='cphExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='cphExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
          <!-- 预约导出弹窗 -->
          <div class="book-export-pop ele-hide" ref="book_export_pop">
            <div class="red-tip">由于当前导出数据量较大，您需操作预约导出，操作预约导出后，需等待系统生成数据，数据生成完成后可在历史预约中下载查看！数据生成过程中可以关闭当前窗口，可再次操作“导出”进入查看导出进度。</div>
            <div class="pop-row center">
              <el-button type="primary" @click="doBookExport">预约导出</el-button>
              <el-button @click="cancelExport">取消</el-button>
            </div>
            <div class="row-tip">历史预约（注：历史预约仅显示该登录账号最近一次预约操作数据）</div>
            <div class="pop-row bottom" v-if="book_export_log_list.length>0">
              <div class="time">{{book_export_log_list[0].create_time}}</div>
              <div class="right">
                <span class="status">{{book_export_log_list[0].status_name}}</span>
                <el-button type="primary" :disabled="book_export_log_list[0].status==0" @click="downloadFile">下载</el-button>
              </div>
            </div>
          </div>
            <!-- 商品类型选择 -->
            <div class="goods-type-pop ele-hide" ref="goods_type_pop">
                <div class="checkbox-wrapper">
                    <el-checkbox v-model="checkAllGoodsType" @change="handleCheckAllGoodsTypeChange">全选</el-checkbox>
                    <el-checkbox-group v-model="cph_goods_type" @change="handleCheckGoodsTypeChange">
                        <el-checkbox v-for="item in cph_goods_type_list" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>
            <!-- 包厢区域选择 -->
            <div class="room-area-pop ele-hide" ref="room_area_pop">
                <div class="checkbox-wrapper">
                    <el-checkbox v-model="checkAllRoomArea" @change="handleCheckAllRoomAreaChange">全选</el-checkbox>
                    <el-checkbox-group v-model="cph_room_area" @change="handleCheckRoomAreaChange">
                        <el-checkbox v-for="item in room_area_list" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>
            <!-- 合计弹窗 -->
            <div class="sum-pop ele-hide" ref="sum_pop">
                <el-table
                    v-loading="pop_loading"
                    element-loading-text="努力加载中，请稍后..."
                    element-loading-background="rgba(0, 0, 0, 0.6)"
                    style="width:100%"
                    :header-cell-style="{'text-align':'center'}"
                    :cell-style="{'text-align':'center'}"
                    :data="sum_table"
                    :key="sumTableKey">
                    <el-table-column prop="sale_quantity" label="销售数量"></el-table-column>
                    <el-table-column prop="pack_quantity" label="套餐数量"></el-table-column>
                    <el-table-column prop="give_quantity" label="赠送数量"></el-table-column>
                    <el-table-column prop="present_quantity" label="配送数量"></el-table-column>
                    <el-table-column prop="exchange_quantity" label="商品兑换数量"></el-table-column>
                    <el-table-column prop="quantity_total" label="出品总量"></el-table-column>
                    <el-table-column prop="price_total" label="出品总额"></el-table-column>
                    <el-table-column prop="buying_price_total" label="进货总额"></el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                cphStartTime: "",
                cphEndTime: "",
                cph_name: "",
                cph_list_total: "0",
                cph_goods_type: [], // 选择的商品类型
                cph_goods_type_list: [], // 全部商品类型
                checkAllGoodsType: false,
                cph_room_area: [], // 选择的包厢区域
                room_area_list: [], // 全部包厢区域
                checkAllRoomArea: false,
                cphExport_allcheck: false,
                c_cphExport_allcheck: false,
                cphExport_checkModel: [],
                cphExport_checkData: ['shop_name', 'room_name', 'goods_type_name', 'goods_name', 'goods_unit_name', 'discount_price', 'sale_quantity', 'pack_quantity', 'give_quantity', 'present_quantity', 'exchange_quantity', 'total_quantity', 'price_total', 'buying_price', 'buying_price_total'],
                cphExport_type: 1,
                list_page: 1,
                book_export_log_list: [], // 历史预约
                sum_table: [],
                pop_loading: false,
                sumTableKey: Math.random(),
                isSuming: false,
                list_page: 1,
                page_size: 10,
            }
        },
        watch: {
            cphExport_checkModel: {
                handler: function(val, oldVal) {
                    if(this.cphExport_checkModel.length >= this.cphExport_checkData.length) {
                        this.cphExport_allcheck = true;
                        this.c_cphExport_allcheck = true;
                    } else {
                        this.cphExport_allcheck = false;
                        this.c_cphExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        computed: {
            room_area_str() {
                if (this.cph_room_area.length == 0) {
                    return ''
                }else if(this.cph_room_area.length == this.room_area_list.length) {
                    return '全部'
                }else {
                    let res = []
                    this.cph_room_area.forEach(v => {
                        this.room_area_list.forEach(item => {
                            if (item.id == v) {
                                res.push(item.name)
                            }
                        })
                    })
                    return res.join(',')
                }
            },
            cph_goods_type_str() {
                if (this.cph_goods_type.length == 0) {
                    return ''
                }else if(this.cph_goods_type.length == this.cph_goods_type_list.length) {
                    return '全部'
                }else {
                    let res = []
                    this.cph_goods_type.forEach(v => {
                        this.cph_goods_type_list.forEach(item => {
                            if (item.id == v) {
                                res.push(item.name)
                            }
                        })
                    })
                    return res.join(',')
                }
            },
        },
        mounted: function() {
            // 日期
            this.cphStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.cphEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.innitDate(); // 日期
            this.shopDatas = [];
            this.innitInput();  // 门店
            this.typeList = [];
            this.getGoodsType();  // 商品类型
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.cphStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.cphEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.cphStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.cphEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.cphTime).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                }, function(start, end, label) {
                    _this.cphStartTime = start.format('YYYY-MM-DD HH:mm');
                    _this.cphEndTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.cph_shop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                _this.setShopDefaultTime(e.params.data.id);
                                _this.cph_room_area = []
                                _this.getRoomArea(e.params.data.id)
                                _this.getStoreList(e.params.data.id)
                                _this.getBillPriceRule(e.params.data.id)
                            });
                            $(_this.$refs.cph_shop).val(data.response.result[1].id).trigger('change');
                            _this.setShopDefaultTime(data.response.result[1].id)
                            _this.getRoomArea(data.response.result[1].id)
                            _this.getStoreList(data.response.result[1].id)
                            _this.getBillPriceRule(data.response.result[1].id)
                            _this.innitSzmTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 商品类型
            getGoodsType: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {

                        }
                    },
                    "comment": []
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getGoodsType",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.cph_goods_type_list = data.response.result.data
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },

            // 打开商品类型选择弹窗
            openGoodsTypePop() {
                let _this = this
                let c_goods_type_ids = _this.cph_goods_type
                _this.checkAllGoodsType = _this.cph_goods_type.length === _this.cph_goods_type_list.length
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择商品类型', true],
                    area: ['650px', ''], // 宽高
                    content: $(_this.$refs.goods_type_pop),
                    cancel: function() {
                        _this.cph_goods_type = c_goods_type_ids
                    }
                }, function() {
                    layer.closeAll()
                }, function() {
                    _this.cph_goods_type = c_goods_type_ids
                    layer.closeAll()
                });
            },

            // 商品类型全选
            handleCheckAllGoodsTypeChange(val) {
                this.cph_goods_type = []
                this.checkAllGoodsType = val
                if (val) {
                    this.cph_goods_type_list.forEach(item => {
                        this.cph_goods_type.push(item.id)
                    })
                }
            },

            // 选择商品类型
            handleCheckGoodsTypeChange(val) {
                this.checkAllGoodsType = val.length === this.cph_goods_type_list.length
            },

             // 获取仓库列表
            getStoreList: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getStoreList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let boxdatas = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result'], function(k, v) {
                                boxdatas.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.ex_store).html('');
                            $(_this.$refs.ex_store).select2({
                                data: boxdatas,
                                minimumResultsForSearch: 1,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },

             // 获取账单价格策略列表
            getBillPriceRule: function(shop_id) {
                const _this = this
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getBillGoodsPriceRule",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: ' ', text: '全部' }];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.bill_price_rule).html('');
                            $(_this.$refs.bill_price_rule).select2({
                                data: arr,
                                minimumResultsForSearch: 1,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.data.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },

            // 获取包厢区域
            getRoomArea: function(shop_id) {
                const _this = this;
                Vue.axios.post('Shop/getRoomArea', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.room_area_list = res.data.response.result;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 打开包厢区域选择弹窗
            openRoomAreaPop() {
                let _this = this
                let c_area_ids = _this.cph_room_area
                _this.checkAllRoomArea = _this.cph_room_area.length === _this.room_area_list.length
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择包厢区域', true],
                    area: ['450px', ''], // 宽高
                    content: $(_this.$refs.room_area_pop),
                    cancel: function() {
                        _this.cph_room_area = c_area_ids
                    }
                }, function() {
                    layer.closeAll()
                }, function() {
                    _this.cph_room_area = c_area_ids
                    layer.closeAll()
                });
            },

            // 包厢区域全选
            handleCheckAllRoomAreaChange(val) {
                this.cph_room_area = []
                this.checkAllRoomArea = val
                if (val) {
                    this.room_area_list.forEach(item => {
                        this.cph_room_area.push(item.id)
                    })
                }
            },

            // 选择包厢区域
            handleCheckRoomAreaChange(val) {
                this.checkAllRoomArea = val.length === this.room_area_list.length
            },

            // 表格
            innitSzmTable: function() {
                let _this = this;
                $(_this.$refs.cphList).bootstrapTable('destroy');
                $(_this.$refs.cphList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getSzmList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "5%",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "8%",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return value.length > '14' ? value.slice(0, 14) + '...' : value
                        }
                    }, {
                        field: "goods_type_name",
                        title: "商品类型",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "goods_name",
                        title: "商品名称",
                        width: "8%",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return value.length > '14' ? value.slice(0, 14) + '...' : value
                        }
                    }, {
                        field: "goods_unit_name",
                        title: "单位",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "discount_price",
                        title: "单价",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "sale_quantity",
                        title: "销售数量",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "pack_quantity",
                        title: "套餐数量",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "give_quantity",
                        title: "赠送数量",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "present_quantity",
                        title: "配送数量",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "exchange_quantity",
                        title: "商品兑换数量",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "total_quantity",
                        title: "出品总量",
                        width: "6%",
                        valign: "middle"
                    },{
                        field: "price_total",
                        title: "出品总额",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "buying_price",
                        title: "进货单价",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "buying_price_total",
                        title: "进货总额",
                        width: "6%",
                        valign: "middle"
                    }],
                });
            },
            getSzmList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                _this.list_page = pageNumber;
                _this.page_size = params.data.limit;
                this.list_page = pageNumber;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_date": _this.cphStartTime,
                            "end_date": _this.cphEndTime,
                            "shop_id": $(_this.$refs.cph_shop).val(),
                            "goods_type": _this.cph_goods_type,
                            "goods_name": _this.cph_name,
                            "room_area": _this.cph_room_area,
                            "store_id": $.trim($(_this.$refs.ex_store).val()),
                            "bill_goods_price_rule_id": $.trim($(_this.$refs.bill_price_rule).val()),
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + 'FinanceReport2/getGoodsSaleCount',
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(pageNumber == 1) {
                                _this.cph_list_total = data.response.result.total_data.total;
                                $(_this.$refs.cph_total).text(data.response.result.total_data.quantity_total);
                            }
                            params.success({
                                total: _this.cph_list_total,
                                rows: data.response.result.data
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getSzmExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport2/exportGoodsSaleCount"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport2/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.cphExport_checkModel = data.response.result.export_fields;
                                _this.cphExport_type = data.response.result.export_type;
                            } else {
                                _this.cphExport_checkModel = _this.cphExport_checkData;
                                _this.cphExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.cphExport_alert)
                }, function() {
                    _this.checkExport();
                });
            },
            // 导出字段全选
            cphExportCheckedAll: function(type) {
                let _this = this;
                _this.cphExport_allcheck = _this.c_cphExport_allcheck;
                if(!_this.cphExport_allcheck) { // 实现全选
                    _this.cphExport_checkModel = [];
                    _this.cphExport_checkData.forEach(function(item) {
                        _this.cphExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.cphExport_checkModel = [];
                }
            },
          // 检查导出状态
          checkExport() {
            let _this = this
            Vue.axios.post('exportBook/exportCheck', {
              "header": Vue.request_header,
              "request": {
                "type": 'goodsSaleCount',
                "param": {
                  "page": _this.list_page,
                  "page_size": _this.GLOBAL.PAGESIZE,
                  "start_date": _this.cphStartTime,
                  "end_date": _this.cphEndTime,
                  "shop_id": $(_this.$refs.cph_shop).val(),
                  "goods_type": $.trim($(_this.$refs.cph_goods_type).val()),
                  "goods_name": _this.cph_name,
                  "room_area": _this.cph_room_area,
                  "store_id": $.trim($(_this.$refs.ex_store).val()),
                  "bill_goods_price_rule_id": $.trim($(_this.$refs.bill_price_rule).val()),
                }
              },
              "comment": ""
            })
                .then(res => {
                  if(res.data.response.result_code == "true") {
                    layer.closeAll()
                    if (res.data.response.result.status == '1') { // 原逻辑直接导出
                      _this.exportSzmList();
                    }else {
                      _this.book_export_log_list = res.data.response.result.log_list
                      // 预约导出弹窗
                      layer.confirm('', {
                        skin: 'public-alert-skin',
                        type: 1,
                        btn: [], // 按钮
                        title: ['导出提示', true],
                        area: ['700px', ''], // 宽高
                        content: $(_this.$refs.book_export_pop),
                        offset: '100px',
                      });
                    }

                  } else {
                    layer.msg(res.data.response.error_msg);
                  }
                })
                .catch(err => {
                  layer.msg("出错啦");
                });
          },

          // 预约导出
          doBookExport() {
            let _this = this;
            let export_fields = JSON.stringify(_this.cphExport_checkModel);

            Vue.axios.post('exportBook/addExportBook', {
              "header": Vue.request_header,
              "request": {
                "type": 'goodsSaleCount',
                "param": {
                  "page": _this.list_page,
                  "page_size": _this.GLOBAL.PAGESIZE,
                  "start_date": _this.cphStartTime,
                  "end_date": _this.cphEndTime,
                  "shop_id": $(_this.$refs.cph_shop).val(),
                  "goods_type": $.trim($(_this.$refs.cph_goods_type).val()),
                  "goods_name": _this.cph_name,
                  "room_area": _this.cph_room_area,
                  "store_id": $.trim($(_this.$refs.ex_store).val()),
                  "bill_goods_price_rule_id": $.trim($(_this.$refs.bill_price_rule).val()),
                  "export_fields": export_fields,
                }
              },
              "comment": ""
            })
                .then(res => {
                  if(res.data.response.result_code == "true") {
                    _this.book_export_log_list = res.data.response.result.log_list
                  } else {
                    layer.msg(res.data.response.error_msg);
                  }
                })
                .catch(err => {
                  layer.msg("出错啦");
                });
          },

          // 下载文件
          downloadFile() {
            // 已知文件的URL
            const fileUrl = this.book_export_log_list[0].file_url
            const fileName = "file.pdf"; // 自定义文件名

            // 创建一个隐藏的 <a> 元素
            const a = document.createElement("a");
            a.href = fileUrl;
            a.download = fileName;

            // 将 <a> 元素添加到页面中
            document.body.appendChild(a);

            // 触发点击事件，下载文件
            a.click();

            // 下载完成后移除该 <a> 元素
            document.body.removeChild(a);
          },

          cancelExport() {
            layer.closeAll()
          },
            // 点击“导出”按钮
            exportSzmList: function() {
                let _this = this;

                let export_fields = JSON.stringify(_this.cphExport_checkModel);
                window.location.href = Vue.ctUrl + "FinanceReport2/exportGoodsSaleCount" +
                    "?start_date=" + _this.cphStartTime +
                    "&end_date=" + _this.cphEndTime +
                    "&shop_id=" + $(_this.$refs.cph_shop).val() +
                    "&goods_type=" + _this.cph_goods_type +
                    "&goods_name=" + _this.cph_name +
                    "&room_area=" + _this.cph_room_area +
                    "&store_id=" + $.trim($(_this.$refs.ex_store).val()) +
                    "&bill_goods_price_rule_id=" + $.trim($(_this.$refs.bill_price_rule).val()) +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.cphExport_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },

            // 查看合计金额
            doSum() {
                if(this.isSuming) {
                    return;
                }
                this.isSuming = true;

                const _this = this;
                _this.pop_loading = true;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": _this.list_page,
                            "page_size": _this.page_size,
                            "start_date": _this.cphStartTime,
                            "end_date": _this.cphEndTime,
                            "shop_id": $(_this.$refs.cph_shop).val(),
                            "goods_type": _this.cph_goods_type,
                            "goods_name": _this.cph_name,
                            "room_area": _this.cph_room_area,
                            "store_id": $.trim($(_this.$refs.ex_store).val()),
                            "bill_goods_price_rule_id": $.trim($(_this.$refs.bill_price_rule).val()),
                        }
                    },
                    "comment": ""
                };

                Vue.axios.post('FinanceReport2/getGoodsSaleCountData', datas)
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.sum_table = []
                        _this.sum_table.push(res.data.response.result);
                        _this.sumTableKey = Math.random();
                        layer.confirm('', {
                            skin: 'public-alert-skin',
                            type: 1,
                            btn: [], // 按钮
                            title: ['合计', true],
                            area: ['1000px', ''], // 宽高
                            content: $(_this.$refs.sum_pop),
                            offset: '260px',
                        });
                    } else {
                        layer.msg(res.data.response.error_msg);
                    }
                    _this.pop_loading = false;
                })
                .catch(err => {
                    layer.msg("出错啦");
                })
                .finally(() => {
                    this.isSuming = false;
                });
            },
        }
    }
</script>
<style lang="less" scoped>
    .flex-row {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .form-control.white {
        background: #fff;
        cursor: pointer;
    }

    .tip {
        margin-right: 20px;
    }
    .goods-type-pop,
    .room-area-pop {
       .el-checkbox {
            width: 150px;
            margin-bottom: 10px;
       }
    }
    .check-sum {
        margin-top: -10px;
        margin-left: 20px;
        color: #409EFF;
        cursor: pointer;
    }
    // 预约导出
    .book-export-pop {
      position: relative;
      .red-tip {
        color: red;
      }
      .pop-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        &.center {
          margin: 30px 0 60px 0;
          justify-content: center;
        }
        &.bottom {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          padding: 0 35px;
          box-sizing: border-box;
          justify-content: space-between;
          .right {
            .status {
              margin-right: 10px;
              color: #409EFF;
            }
          }
        }
      }
      .row-tip {
        margin-bottom: 20px;
      }
      .el-button {
        width: 100px;
      }
    }
</style>